import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getAvailableCurrencies } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.selectors';
import { getDeployment } from '@/redux/modules/config';
import {
    getHouseBillingCurrencyOptions,
    putHouseBillingCurrency,
} from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.api';
import { HouseBillingCurrency } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.types';

export const fetchHouseBillingCurrencyOptions = createAsyncThunk<HouseBillingCurrency[], void>(
    'la/ui/houseBillingCurrency/fetchHouseBillingCurrencyOptions',
    async (_, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const { payload } = await getHouseBillingCurrencyOptions({
            authToken,
            deployment,
        });
        return payload;
    },
    {
        condition: (_, { getState }) => getAvailableCurrencies(getState()).length === 0,
    }
);

type SaveHouseBillingCurrencyParams = {
    currency: Parameters<typeof putHouseBillingCurrency>[0]['currency'];
    houseId: number;
};

export const saveHouseBillingCurrency = createAsyncThunk<
    Awaited<ReturnType<typeof putHouseBillingCurrency>>['payload'],
    SaveHouseBillingCurrencyParams
>('la/ui/houseBillingCurrency/saveHouseBillingCurrency', async (params, { getState }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);
    const { payload } = await putHouseBillingCurrency({
        authToken,
        deployment,
        ...params,
    });
    return payload;
});
